import { createSelector } from 'reselect';

export const selectedExpertExpertisePage = (state: any) => {
  return state.get('expertExpertise');
};

const makeSelectVictimExpertise = () =>
  createSelector(selectedExpertExpertisePage, expertExpertiseStore => {
    if (expertExpertiseStore && expertExpertiseStore.get('expertiseVictim')) {
      return expertExpertiseStore.get('expertiseVictim').toJS();
    }
    return [];
  });
const makeSelectMissionPostPonse = () =>
  createSelector(selectedExpertExpertisePage, expertExpertiseStore => {
    if (expertExpertiseStore && expertExpertiseStore.get('missionPostPone')) {
      return expertExpertiseStore.get('missionPostPone').toJS();
    }
    return [];
  });
const makeSelectMissionPostPonseExpertise = () =>
  createSelector(selectedExpertExpertisePage, expertExpertiseStore => {
    if (
      expertExpertiseStore &&
      expertExpertiseStore.get('missionPostPoneExpertise')
    ) {
      return expertExpertiseStore.get('missionPostPoneExpertise').toJS();
    }
    return [];
  });
export {
  makeSelectVictimExpertise,
  makeSelectMissionPostPonse,
  makeSelectMissionPostPonseExpertise,
};
